import styled from 'styled-components'

export const LoginForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  width: 384px;
  height: 100vh;
  margin: auto;
`;